<template>
  <svg width="18" height="10" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path d="M-7 21h32v-32H-7z"/>
      <path stroke="#515166" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1 1l8 8 8-8"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'ic-dropdown'
  }
</script>

